<div class="layout-sidebar" (click)="onMenuClick($event)" (mouseenter)="app.onMenuMouseEnter($event)"
    (mouseleave)="app.onMenuMouseLeave($event)">
    <div class="layout-sidebar-logo flex  flex-column  row-gap-4">
        <div class="flex align-items-center justify-content-center">
            <img class="logoIcon" src="assets/layout/images/logo-horizontal-plannerbus.jpg" alt="manhattan-layout"
                style="background: white;
            border-radius: 10px; height: 40px; padding:5px 5px 5px 5px" />
        </div>
        <!-- <a routerLink="/"> -->

        <!-- </a> -->
        <div class="flex align-items-center justify-content-center text-white font-medium text-lg uppercase"
            style="letter-spacing: 1px;">
            {{auth.currentDns}}
        </div>
        <a href="#" id="layout-sidebar-anchor" class="layout-sidebar-anchor" title="Slim Menu"
            (click)="app.onAnchorClick($event)">
            <i class="fa-circle" [ngClass]="app.slimMenuAnchor ? 'fa-solid' : 'fa-regular'"></i>
        </a>
    </div>
    <div class="layout-menu-container">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
        <div class="absolute flex flex-column justify-content-center w-full bottom-0 left-0 ">
            <ng-container *ngFor="let enum of switchAppItems">
                <p-button class="text-center"
                    *ngIf="(appCom.switchApp | async) != enum && auth.currentUserValue[enum.authexist]"
                    styleClass="p-button-outlined surface-100 mb-4" (onClick)="onClickSwitchApp(enum)">
                    <img alt="logo" [src]="enum.image" style="width: 2.5rem" />
                    <span class="ml-0 font-bold text-2xl px-3 text-600">{{enum.text}}</span>
                </p-button>
            </ng-container>
        </div>
    </div>
    <div class="layout-menu-footer">v. {{version}}</div>
</div>